import { toast } from "react-toastify";

export enum ErrorType {
  CLIENT = "Client Error",
  SERVER = "Server Error",
  NETWORK = "Network Error",
  UNKNOWN = "Unknown Error",
}

export class AppError extends Error {
  type: ErrorType;
  status: number;

  constructor(message: string, type: ErrorType, status: number) {
    super(message);
    this.type = type;
    this.status = status;
  }
}

export const handleError = (error: any): AppError => {
  if (error.response) {
    const status = error.response.status;
    const message =
      error.response.data?.message || `Server responded with status ${status}`;
    const type =
      status >= 400 && status < 500 ? ErrorType.CLIENT : ErrorType.SERVER;
    return new AppError(message, type, status);
  } else if (error.request) {
    return new AppError(
      "No response from server. Please check your network connection.",
      ErrorType.NETWORK,
      0
    );
  } else {
    return new AppError(error.message, ErrorType.UNKNOWN, 0);
  }
};

export const notifyError = (appError: AppError) => {
  toast.error(`${appError.type}: ${appError.message}`, {
    position: "top-right",
    autoClose: 5000,
  });
};
